import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { AbstractControl, UntypedFormGroup } from '@angular/forms';
import { faXmark } from '@fortawesome/pro-solid-svg-icons';

import { PhoneTypeCodeMap } from '../../../data/phone-type';
import { PhoneTypeModel } from '../../../model/phone-type.model';
import { PhoneComponent } from '../phone.component';
import { PhoneTypeKeyMap } from './../../../data/phone-type';

@Component({
  selector: 'app-phone-field',
  templateUrl: './phone-field.component.html',
  styleUrls: ['./phone-field.component.css']
})
export class PhoneFieldComponent implements OnInit, OnDestroy {

  public faXmark = faXmark;

  @Input()
  public Title: string;

  @Input()
  public group: UntypedFormGroup;

  @Input()
  public index: number;

  @Input()
  public last: boolean;

  public PhoneType: PhoneTypeModel;

  constructor(
    private parent: PhoneComponent
  ) {
  }

  ngOnInit() {
    if (this.group.value.cph_pht_key) {
      const cph_pht_key = this.group.value.cph_pht_key;
      if (cph_pht_key in PhoneTypeKeyMap) {
        this.PhoneType = PhoneTypeKeyMap[cph_pht_key];
      }
    } else {
      this.PhoneType = PhoneTypeCodeMap['Landline'];
      this.group.get('cph_pht_key').setValue(this.PhoneType.pht_key);
    }
  }

  ngOnDestroy(): void {
  }

  public changeType(value: 'Mobile' | 'Landline', $event: Event) {
    $event.preventDefault();

    if (value in PhoneTypeCodeMap) {
      this.PhoneType = PhoneTypeCodeMap[value];
      this.group.get('cph_pht_key').setValue(this.PhoneType.pht_key);
    }
  }

  public removePhone($event: Event) {
    if (this.index > 0) {
      $event.preventDefault();
      this.parent.removePhone(this.index);
    }
  }
}
